module.exports = __webpack_public_path__ + "img/auth.ff3302f2.png";